import { API, graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import moment from "moment";

const initialState = {
  status: "idle",
  items: [],
  item: {},
};

const lookups = (state = initialState, action) => {
  const convertItemDates = (item) => {
    let ModifiedOn = moment(item.ModifiedOn).unix();
    return {
      ...item,
      ModifiedOn: moment.unix(ModifiedOn).format(action.config.FORMAT_DATETIME),
    };
  };

  const convertItem = (item) => ({
    ...item,
    CreatedOn: moment
      .unix(item.CreatedOn)
      .format(action.config.FORMAT_DATETIME),
    ModifiedOn: moment
      .unix(item.ModifiedOn)
      .format(action.config.FORMAT_DATETIME),
  });

  switch (action.type) {
    case "lookup/loading":
    case "lookups/loading":
      return {
        ...state,
        status: "loading",
      };
    case "lookups/loaded":
      return {
        ...state,
        status: "idle",
        items: action.lkitems.map((item) => convertItem(item)),
      };
    case "lookup/loaded":
      return {
        ...state,
        item: convertItem(action.lkitems),
        status: "idle",
      };
    case "cidrlookup/loaded":
      return {
        ...state,
        item: action.lkitems,
        status: "idle",
      };
    case "lookup/updated":
      return {
        ...state,
        status: "idle",
        items: state.items.map((item) =>
          item.id === action.payload.id
            ? convertItemDates({
                ...item,
                ...action.payload,
              })
            : item
        ),
        item:
          state.item.id === action.payload.id
            ? convertItemDates({
                ...state.item,
                ...action.payload,
              })
            : undefined,
      };
    case "lookup/create":
      return {
        ...state,
        status: "idle",
        items: state.items.concat(convertItem(action.payload, [])),
      };
    case "lookup/loadError":
    case "lookups/loadFailed":
    case "lookup/updateFailed":
      return {
        ...state,
        status: "idle",
      };
    case "lookup/dismiss":
      return initialState;
    default:
      return state;
  }
};

export const fetchLookups =
  (showStatus = true) =>
  async (dispatch, getState) => {
    try {
      if (showStatus) {
        dispatch({ type: "lookups/loading" });
      }
      const response = await API.graphql(
        graphqlOperation(queries.safeOperatorApi, { action: "listLookups" })
      );
      const payload = JSON.parse(response.data.safeOperatorApi);
      let lookupsItems = [];
      if (!payload || payload.status === "error") {
        throw payload;
      }
      if (payload.status === "success") {
        lookupsItems = payload.body.lookups;
      }
      dispatch({
        type: "lookups/loaded",
        lkitems: lookupsItems,
        config: getState().config,
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: "lookups/loadFailed" });
      dispatch({
        type: "notification/error",
        message: "Error loading lookups list.",
      });
    }
  };

export const fetchCIDRLookup =
  (showStatus = true) =>
  async (dispatch, getState) => {
    try {
      if (showStatus) {
        dispatch({ type: "lookups/loading" });
      }
      const response = await API.graphql(
        graphqlOperation(queries.safeOperatorApi, { action: "listCIDRLookup" })
      );
      const payload = JSON.parse(response.data.safeOperatorApi);
      let lookupItem = [];
      if (!payload || payload.status === "error") {
        throw payload;
      }
      if (payload.status === "success") {
        lookupItem = payload.body.lookup;
      }
      // return lookupItem;
      dispatch({
        type: "cidrlookup/loaded",
        lkitems: lookupItem,
        config: getState().config,
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: "lookups/loadFailed" });
      dispatch({
        type: "notification/error",
        message: "Error loading CIDR lookups list.",
      });
    }
  };

export const updateLookup = (newvalue) => async (dispatch, getState) => {
  try {
    const config = getState().config;
    const response = await API.graphql(
      graphqlOperation(queries.safeOperatorApi, {
        action: "updateLookup",
        paramJson: JSON.stringify(newvalue),
      })
    );
    dispatch({
      type: "lookup/updated",
      payload: { newvalue },
      config,
    });

    const payload = JSON.parse(response.data.safeOperatorApi);
    if (!payload || payload.status !== "success") {
      throw payload;
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "lookup/updateFailed" });
    dispatch({
      type: "notification/error",
      message: "Error updating lookup۔",
    });
  }
};

export default lookups;
